import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ResponsiveToastContainer } from './components/Toast';
import AppRoutes from './routes/AppRoutes';

function App() {
    return (
        <Router>
            <AppRoutes />
            <ResponsiveToastContainer />
        </Router>
    );
}

export default App;
